import type {State} from '../reducers'

export const getLocale = (state: State) => state.environment.locale

export const isAndroid = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('android') > -1
}
